import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './RfiQuestions.css';
import moment from 'moment';
import { Table } from 'react-bootstrap';
import { RfiStatusEnum } from 'domain/rfi-status-enum';
import { searchDirectory } from 'components/admin/projects/details/project-directory/store/actions';
import { getRfiQuestions } from 'components/admin/projects/details/project-rfi-log/store/selectors';
import RfiQuestion from 'components/admin/projects/details/project-rfi-log/RfiQuestion';
import {
  updateRfiFormValue,
  addRfiQuestion,
  attachRfiQuestions,
  deleteRfiQuestion,
  updateRfiQuestionValue,
  loadRfiQuestionNotes,
  markRfiQuestionNotesRead,
  createRfiQuestionNote,
  deleteQuestionFile,
} from 'components/admin/projects/details/project-rfi-log/store/actions';
import { formatNumber } from 'services/utils/text-util';
import { getRfiForm } from 'components/admin/projects/details/project-rfi-log/store/selectors';

class RfiQuestions extends Component {
  static propTypes = {
    currentUser: PropTypes.shape({}).isRequired,
    contribType: PropTypes.string.isRequired,
    project: PropTypes.shape({}).isRequired,
    currentRfi: PropTypes.shape({}),
    readOnly: PropTypes.bool,
    modalReadOnly: PropTypes.bool,
    gcAcceleration: PropTypes.bool,
  };

  constructor(props) {
    super(props);

    if (props.currentRfi) {
      this.initQuestions(props.currentRfi);
    } else {
      this.handleAddAdditionalRfi();
    }
  }

  initQuestions = (rfi) => {
    const { currentUser, modalReadOnly } = this.props;
    const questions = rfi.rfi_questions.map((qus) => {
      const addlAssignee = qus.rfi_addl_assignees.find(
        (addlAssignee) => addlAssignee.assignee_id === currentUser.id
      );
      return {
        ...qus,
        notesReadBy: qus.notes_read_by,
        assignee: qus.assignee
          ? [
              qus.assignee.id,
              this.userLabelStr(qus.assignee, qus.assignee.accountable),
            ]
          : [],
        addlAssignees: qus.rfi_addl_assignees.map((addlAssignee) => {
          return {
            id: addlAssignee.id,
            assigneeId: addlAssignee.assignee_id,
            assigneeLabel: addlAssignee.assignee_label,
            dueDate: addlAssignee.due_date,
            respondedAt: addlAssignee.responded_at,
            response: addlAssignee.response,
          };
        }),
        response:
          addlAssignee && !modalReadOnly ? addlAssignee.response : qus.response,
        reqDocsDelete: [],
        reqImagesDelete: [],
        resDocsDelete: [],
        resImagesDelete: [],
        errors: {},
      };
    });

    this.props.dispatch(attachRfiQuestions(questions));
  };

  assigneeChanged = (questionKey) => {
    const { questions } = this.props;
    const allAssigned = !Object.keys(questions).find(
      (key) => key !== questionKey && questions[key].assignee.length === 0
    );

    if (allAssigned) {
      this.props.dispatch(
        updateRfiFormValue('status', RfiStatusEnum.ASSIGNED.status)
      );
    }
  };

  resolvedChanged = (questionKey) => {
    const { questions } = this.props;
    const allResolved = !Object.keys(questions).find(
      (key) => key !== questionKey && !questions[key].resolved
    );

    if (allResolved) {
      this.props.dispatch(
        updateRfiFormValue('status', RfiStatusEnum.RESOLVED.status)
      );
    }
  };

  userLabelStr = (user, company) => {
    if (company) {
      return `${user.first_name} ${user.last_name} - ${
        company.name || company.company_name
      }`;
    } else {
      return `${user.first_name} ${user.last_name} - Spackle`;
    }
  };

  loadContributors = () => {
    let users = {};
    return this.props
      .dispatch(searchDirectory(this.props.project.id))
      .then((response) => {
        if (response.ok) {
          const contributors = response.directory.project_contributors
            .filter(
              (pc) => pc.primary && pc.company_type !== 'GeneralContractor'
            )
            .map((pc) => {
              return pc.users
                .filter((usr) => !users[usr.id])
                .map((usr) => {
                  users[usr.id] = true;
                  return {
                    value: usr.id,
                    label: this.userLabelStr(usr, pc.company),
                  };
                });
            })
            .reduce((acc, val) => acc.concat(val), []);

          return {
            ok: true,
            options: contributors,
          };
        }
      });
  };

  loadRfiQuestionNotes = (questionKey, question) => {
    this.props.dispatch(
      markRfiQuestionNotesRead(questionKey, question, this.props.currentUser.id)
    );
    return this.props.dispatch(loadRfiQuestionNotes(questionKey, question.id));
  };

  createRfiQuestionNote = (questionKey, questionId, content) => {
    return this.props.dispatch(
      createRfiQuestionNote(questionKey, questionId, content)
    );
  };

  mapRfiQuestions = () => {
    const showNotes = this.showNotes();
    let questions = Object.keys(this.props.questions).map((key) => {
      const question = this.props.questions[key];
      return (
        <RfiQuestion
          key={key}
          currentUser={this.props.currentUser}
          contribType={this.props.contribType}
          dueDate={this.props.form.extendedDueDate || this.props.form.dueDate}
          questionKey={key}
          question={question}
          assigneeChanged={this.assigneeChanged}
          resolvedChanged={this.resolvedChanged}
          loadContributors={this.loadContributors}
          loadQuestionNotes={this.loadRfiQuestionNotes}
          createQuestionNote={this.createRfiQuestionNote}
          handleQuestionChange={this.handleRfiQuestionChange}
          handleQuestionDeleteFile={this.handleRfiQuestionDeleteFile}
          readOnly={this.props.readOnly}
          modalReadOnly={this.props.modalReadOnly}
          gcAcceleration={this.props.gcAcceleration}
          showNotes={showNotes}
        />
      );
    });

    if (!this.props.readOnly) {
      questions.push(
        <tr key="add-row">
          <td></td>
          <td>
            <div className="add-row-container">
              <div
                className="tomato-row add-row"
                onClick={this.handleAddAdditionalRfi}
              >
                <div className="add-row-message">
                  <span className="add-row-plus">+ </span>
                  {questions.length === 0 ? 'Add RFI' : 'Add Additional RFI'}
                </div>
              </div>
              {questions.length > 1 && (
                <div className="add-row" onClick={this.handleDeleteRfi}>
                  <div className="add-row-message">
                    <span className="add-row-plus">- </span>Delete RFI
                  </div>
                </div>
              )}
            </div>
          </td>
        </tr>
      );
    }

    return questions;
  };

  showNotes = () => {
    const { currentRfi } = this.props;
    return (
      !!currentRfi &&
      !RfiStatusEnum.DRAFT.equals(RfiStatusEnum.create(currentRfi.status))
    );
  };

  handleRfiQuestionChange = (key, attribute, value) => {
    this.props.dispatch(updateRfiQuestionValue(key, attribute, value));
  };

  handleRfiQuestionDeleteFile = (key, attribute, value) => {
    this.props.dispatch(deleteQuestionFile(key, attribute, value));
  };

  handleAddAdditionalRfi = () => {
    const key = Object.keys(this.props.questions).length + 1;
    this.props.dispatch(
      addRfiQuestion(key, {
        number: key,
        action: '',
        question: '',
        response: '',
        resolved: false,
        assignee: [],
        addlAssignees: [],
        rfi_addl_assignees: [],
        reqDocs: [],
        reqImages: [],
        reqDocsDelete: [],
        reqImagesDelete: [],
        resDocs: [],
        resImages: [],
        resDocsDelete: [],
        resImagesDelete: [],
      })
    );
  };

  handleDeleteRfi = () => {
    const { questions, dispatch } = this.props;
    const keys = Object.keys(questions);
    const key = keys[keys.length - 1];
    dispatch(deleteRfiQuestion(key));
  };

  render() {
    const { currentUser, currentRfi, questions } = this.props;
    return (
      <div className="rfi-questions">
        <h3 className="rfi-title">
          {currentRfi
            ? `RFI #${formatNumber(currentRfi.number)} ${
                currentRfi.title ? ` - ${currentRfi.title}` : ''
              }`
            : 'Request For Information'}
        </h3>

        <p className="rfi-submitted-by">
          Submitted by
          {currentRfi && currentRfi.submitted_by ? (
            <span>
              &nbsp;
              {this.userLabelStr(
                currentRfi.submitted_by,
                currentRfi.submitted_by.accountable
              )}
              &nbsp;on{' '}
              {moment(currentRfi.submitted_at || currentRfi.received_at).format(
                'MM/DD/YY'
              )}
            </span>
          ) : (
            <span>
              &nbsp;{this.userLabelStr(currentUser, currentUser.accountable)}
              &nbsp;on {moment().format('MM/DD/YY')}
            </span>
          )}
        </p>

        {currentRfi &&
          Object.keys(questions)
            .filter((key) => {
              const qus = questions[key];
              return !!qus.response && !!qus.responded_by && !!qus.responded_at;
            })
            .map((key) => {
              const qus = questions[key];
              return (
                <p key={key} className="rfi-responded-by">
                  {qus.number}. Responded by
                  <span>
                    &nbsp;
                    {this.userLabelStr(
                      qus.responded_by,
                      qus.responded_by.accountable
                    )}
                    &nbsp;on {moment(qus.responded_at).format('MM/DD/YY')}
                  </span>
                </p>
              );
            })}

        <Table className="simple-table rfi-questions-table">
          <colgroup>
            <col key={1} />
            <col key={2} />
          </colgroup>
          <tbody>{this.mapRfiQuestions()}</tbody>
        </Table>
      </div>
    );
  }
}

export default connect((state) => {
  return {
    questions: getRfiQuestions(state),
    form: getRfiForm(state),
  };
})(RfiQuestions);



// WEBPACK FOOTER //
// ./src/components/admin/projects/details/project-rfi-log/RfiQuestions.js